import React, { Component } from 'react'
import '../styles/Reports.css'
import ReportFarmerML from './ReportFarmerML'
import ReportSiteML from './ReportSiteML'
import ReportClusterML from './ReportClusterML'
import ReportOrganizationML from './ReportOrganizationML'
import ReportSiteProvincial from './ReportSiteProvincial'
import ReportSiteRegional from './ReportSiteRegional'
import ReportSiteNational from './ReportSiteNational'

class ReportDetails extends Component
{
	constructor(props) {
		super(props)
		const user = JSON.parse(sessionStorage.getItem("user"))
		console.log('user', user)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			disabled: props.disabled,
			roleId: user.role_id
		}
		this.onSubmit = this.onSubmit.bind(this)
		this.setContent = this.setContent.bind(this)
		this.eventHandler = this.eventHandler.bind(this)
	}

	onSubmit() {
	}

	componentDidMount() {
		this.setContent(sessionStorage.getItem("report-tabId"))
	}

	eventHandler(e) {
		this.props.selectView(sessionStorage.getItem("report-curr-view"), this.props.siteId, e)
	}

	setContent(id) {
		console.log('report details set content', id)
		let isDisabled = (this.props.view === "update")? false: true
		let content
		switch(id) {
			case "rdh-cluster":
				switch(this.state.roleId) {
					case 3:
					case 7:
						content = <ReportClusterML siteId={this.props.siteId} disabled={isDisabled} key={Math.random()} />
						break
					case 7:
						content = <ReportClusterML siteId={this.props.siteId} disabled={isDisabled} key={Math.random()} />
						break
					case 7:
						content = <ReportClusterML siteId={this.props.siteId} disabled={isDisabled} key={Math.random()} />
						break
					case 7:
						content = <ReportClusterML siteId={this.props.siteId} disabled={isDisabled} key={Math.random()} />
				}
				break
			case "rdh-organization":
				switch(this.state.roleId) {
					case 3:
					case 7:
						content = <ReportOrganizationML siteId={this.props.siteId} disabled={isDisabled} key={Math.random()} />
						break
					case 7:
						content = <ReportOrganizationML siteId={this.props.siteId} disabled={isDisabled} key={Math.random()} />
						break
					case 7:
						content = <ReportOrganizationML siteId={this.props.siteId} disabled={isDisabled} key={Math.random()} />
						break
					case 7:
						content = <ReportOrganizationML siteId={this.props.siteId} disabled={isDisabled} key={Math.random()} />
				}
				break;
			case "rdh-farmer":
				switch(this.state.roleId) {
					case 3:
					case 7:
						content = <ReportFarmerML siteId={this.props.siteId} key="report-farmer" />
						break
					case 4:
						// content = <ReportFarmerProvincial siteId={this.props.siteId} key="report-farmer" />
						break
					case 5:
						// content = <ReportFarmerRegional siteId={this.props.siteId} key="report-farmer" />
						break
					case 6:
						// content = <ReportFarmerNational siteId={this.props.siteId} key="report-farmer" />
						break
				}
				break
			default:
				switch(this.state.roleId) {
					case 3:
					case 7:
						content = <ReportSiteML siteId={this.props.siteId} key="site" />
						break
					case 4:
						content = <ReportSiteProvincial key="site" />
						break
					case 5:
						content = <ReportSiteRegional key="site" />
						break
					case 6:
						content = <ReportSiteNational key="site" />
						break
				}
		}
		this.setState({
			content: content
		})
	}

	render() {
		const view = <div id="report-details">
			<Header onItemClick={(item) => {
				this.setContent(item)
			}} disabled={this.state.disabled} />
			<Body
				content={this.state.content}
			/>
		</div>
		return(view)
	}
}

class Header extends Component
{
	constructor(props) {
		super(props)
		this.state = {disabled: props.disabled}
		this.onItemClick = this.onItemClick.bind(this)
		this.mouseEnter = this.mouseEnter.bind(this)
		this.mouseLeave = this.mouseLeave.bind(this)
	}

	componentDidMount() {
		if(this.state.disabled) {
			return
		}
		const items = document.querySelectorAll('#report-details-header > div')
		for(const f of items) {
			f.style.color = "#000"
		}
		const imgs = document.querySelectorAll('#report-details-header > div > img')
		for(const f of imgs) {
			f.style.opacity = "1.0"
		}
		const tabId = sessionStorage.getItem("report-tabId")
		switch(tabId) {
			case "rdh-cluster":
				var elem = document.getElementById("rdh-cluster")
				break
			case "rdh-organization":
				elem = document.getElementById("rdh-organization")
				break
			case "rdh-farmer":
				elem = document.getElementById("rdh-farmer")
				break
			default:
				elem = document.getElementById("rdh-site")
		}
		elem.style.background = "#e2e2e2"
	}

	componentDidUpdate(prevProps) {
		if(this.props.disabled != prevProps.disabled) {
			this.setState({disabled: this.props.disabled})
			if(this.props.disabled) {
				return
			}
			const items = document.querySelectorAll('#report-details-header > div')
			for(const f of items) {
				f.style.color = "#000"
			}
			const imgs = document.querySelectorAll('#report-details-header > div > img')
			for(const f of imgs) {
				f.style.opacity = "1.0"
			}
		}
	}

	onItemClick(e) {
		if(this.state.disabled) {
			return
		}
		const items = document.querySelectorAll('#report-details-header > div')
		for(const f of items) {
			f.style.background = "#ffffff"
		}
		e.target.style.background = "#e2e2e2"
		this.props.onItemClick(e.target.id)
	}

	mouseEnter(e) {
		if(this.state.disabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#e2e2e280"
	}

	mouseLeave(e) {
		if(this.state.disabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#ffffff"
	}

	render() {
		const view = <div id="report-details-header">
			<div id="rdh-site" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}>SITE</div>
			<div id="rdh-cluster" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}>CLUSTERS</div>
			<div id="rdh-organization" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}>ORGANIZATIONS</div>
			<div id="rdh-farmer" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}>FARMERS</div>
		</div>
		return(view)
	}
}

class Body extends Component
{
	constructor(props) {
		super(props)
		this.onItemClick = this.onItemClick.bind(this)
	}

	onItemClick(e) {
		console.log(e.target.id)
	}

	render() {
		const view = <div id="report-details-body">
			<div id="rdb-content">
				{this.props.content}
			</div>
		</div>
		return(view)
	}
}

export default ReportDetails
